import React from "react";
import PropTypes from "prop-types";
import {
  APPROVAL_STATUSES,
  APPROVED,
  DENIED,
  PENDING,
  MANAGER_CONSENT_NEEDED
} from "MODULES/companies/constants";

const statusInfo = {
  [PENDING]: {
    css: "label-warning",
    icon: "fa-warning",
    text: "Repair Station Pending"
  },
  [APPROVED]: {
    css: "label-success",
    icon: "fa-check",
    text: "Repair Station Approved"
  },
  [DENIED]: {
    css: "label-danger",
    icon: "fa-times",
    text: "Repair Station Denied"
  },
  [MANAGER_CONSENT_NEEDED]: {
    css: "label-warning",
    icon: "fa-check",
    text: "Mgmt. Consent Needed"
  }
};

export default function Status({ status }) {
  const info = statusInfo[status];
  if (!info) {
    return <span />;
  }

  return (
    <span className={`label ${info.css}`}>
      <i className={`fa ${info.icon}`} />
      &nbsp;&nbsp;
      {info.text}
    </span>
  );
}

Status.propTypes = {
  status: PropTypes.oneOf(Object.keys(APPROVAL_STATUSES)).isRequired
};



// WEBPACK FOOTER //
// ./app/modules/companies/components/Search/RepairStationStatus.jsx